<script lang="ts">
	import type { Page } from '$models/Page/Page';

	let { page }: { page: Page } = $props();
</script>

<div class="header-spacing header-page-type-{page.type}"></div>

<style lang="postcss" global>
	:root {
		--header-nav-height: 104px;
	}

	html:has(.header-promotion-bar) {
		--header-spacing-height: calc(var(--promotion-bar-height) + var(--header-nav-height));
		--header-overlap-height: var(--header-nav-height);

		@media (--xl) {
			--header-nav-height: 122px;
		}
	}

	.header-spacing {
		width: 100%;
		height: var(--header-spacing-height, var(--header-nav-height));
		background-color: transparent;

		&.header-page-type-author,
		&.header-page-type-account,
		&.header-page-type-blogOverview,
		&.header-page-type-checkout {
			background-color: var(--variant-tint-1-color);
		}

		&.header-page-type-shop,
		&.header-page-type-shop-item-detail {
			background-color: white;
		}

		+ .block-panorama {
			margin-top: calc(-1 * var(--header-spacing-height, var(--header-nav-height)));
		}
	}

	.header.has-promotion-bar + .header-spacing + .block-panorama {
		margin-top: calc(-1 * var(--header-overlap-height) - 1px);
	}
</style>
